import styled from '@emotion/styled';

import { COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const ContentContainer = styled.div`
  padding: 0 ${SPACING.S32} ${SPACING.S32} ${SPACING.S32};
  width: 100%;

  ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
  ${MEDIA_QUERY.TABLET} {
    width: 600px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    width: 800px;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    width: 1049px;
  }
`;

export const Header = styled.h1`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGE)};
  colors: ${COLORS.BLACK};
  font-family: ${FONT.FONT_FAMILY_PROXIMA};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: 0 0 ${SPACING.S32} 0;
  padding: 0;
`;

export const ListContainer = styled.section`
  height: 450px;
  margin-bottom: ${SPACING.S32};
  overflow-y: auto;
`;

export const ActionsContainer = styled.section`
  text-align: right;
`;
